module.exports = __webpack_public_path__ + "bigi-logo-text.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-types/assets/bigi-logo-text.png
// module id = 1120
// module chunks = 10